import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HighlightNew } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';
import { ModalShareComponent } from '../../../blocks/modal-share/modal-share.component';

@Component({
  selector: 'app-sample-news-big',
  templateUrl: './sample-news-big.component.html',
  styleUrls: ['./sample-news-big.component.scss']
})
export class SampleNewsBigComponent implements OnInit {

  @Input() dataNews: HighlightNew = {} as HighlightNew;
  public stringTaxonomies: string = '';
  public domainWebsite = environment.urlApi;
  public isLinkEsternal: boolean = false;
  public imgPath = '';
  public image_alt = '';
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };

  constructor(
    private helperService: HelpersService,
    private modalService: NgbModal,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    if (this.dataNews) {
      this.setVariable();
      this.setLabelTags();
    }
  }

  private setVariable() {
    this.objTitle = this.helperService.retriveLinkTagA(this.dataNews.field_titolo, "a");
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.dataNews.field_immagine, "src");
    this.image_alt = this.helperService.retrieveImage(this.dataNews.field_immagine, "alt");
    this.isLinkEsternal = this.objTitle ? this.helperService.verifyLinkExternal(this.objTitle.link) : false;
  }

  private setLabelTags() {
    let taxonomies: string[] = [];
    if (this.dataNews.field_tassonomia_area_universita) {
      this.dataNews.field_tassonomia_area_universita.forEach((tag, idx) => {
        if (idx < 3) {
          taxonomies.push(tag.name);
        }
      });
      if (this.dataNews.field_tassonomia_area_universita.length > 3) {
        taxonomies.push(`+${this.dataNews.field_tassonomia_area_universita.length - 3}`)
      }
    }
    this.stringTaxonomies = taxonomies.join(', ');
  }

  public openModaleShare(): void {
    const modalRef = this.modalService.open(ModalShareComponent, {
      scrollable: false,
      centered: true,
      size: 'lg',
    });
    let data: any;
    const path: string = this.objTitle.link;
    
    data = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${path}`,
      twitter: `http://twitter.com/share?text=Im%20sharing%20on%20Twitter&url=${path}`,
      linkedin: `https://linkedin.com/sharing/share-offsite/?url=${path}`,
      copy_text: path
    };
    modalRef.componentInstance.fromParent = data;
  }

}
